/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export enum ScalarOperators {
  IN_OPERATOR = 'IN',
  NOT_IN_OPERATOR = 'NOT_IN',
  SCALAR_OPERATOR_UNSPECIFIED = 'UNSPECIFIED'
}
